import cookieManager from '../../../../utils/cookieManager';
import axios from '@/enhancers/axios';
import DailyAttendanceActions from '../../../../reducers/modules/hr/daily-attendance/actions';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { Navigate } from 'react-router-dom';

const MySwal = withReactContent(Swal)
const url=process.env.REST_URL +'hr/daily-attendance'

export default class DailyAttendanceMiddleware {

  static create(params){
    return (dispatch) => {
      dispatch(DailyAttendanceActions.create());
    };
  }

  static update(params){
    return (dispatch) => {
      DailyAttendanceMiddleware.showOne(dispatch, params);
      dispatch(DailyAttendanceActions.update());
    };
  }
  static resetList(){
    return (dispatch) => {
        dispatch(DailyAttendanceActions.resetList());
      };
  }
  static list(params){
      return (dispatch) => {
          dispatch(DailyAttendanceActions.process());
          DailyAttendanceMiddleware.showlist(dispatch, params);
        };
  }
  static reset(){
    return (dispatch) => {
        dispatch(DailyAttendanceActions.reset());
      };
}
  static getOne(params){
    return (dispatch) => {
        dispatch(DailyAttendanceActions.view());
        DailyAttendanceMiddleware.showOne(dispatch, params);
      };
  }

  static beforeSaveNew(post,search){
    return (dispatch) => {
        dispatch(DailyAttendanceActions.submit());
        DailyAttendanceMiddleware.saveNew(dispatch, post,search);
      };
  }
  static beforeSaveUpdate(post,params){
    return (dispatch) => {
        dispatch(DailyAttendanceActions.submit());
        DailyAttendanceMiddleware.saveUpdate(dispatch, params, post);
      };
  }
  static beforeDelete(id,params){
    return (dispatch) => {
        dispatch(DailyAttendanceActions.delete());
        DailyAttendanceMiddleware.delete(dispatch,params,id);
      };
  }

  static getToken(){
      return cookieManager.getUserToken();
  }

  static getHelper(params=null){
    return (dispatch) => {
      DailyAttendanceMiddleware.showHelper(dispatch,params);
      };
  }

 
  static showHelper(dispatch,params){
    axios({
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${DailyAttendanceMiddleware.getToken()}`
        },
        url:process.env.REST_URL+'helper/get-helper-daily-attendance' ,
        responseType: 'json',
        params:params
      })
      .then((response) => {
        
        if (response && response.status === 200 && response.data) {
          dispatch(DailyAttendanceActions.helper(response.data.result));
        }
      })
      .catch((error) => {
        DailyAttendanceMiddleware.alertHendler(dispatch,error)
      });
  }

  static showlist(dispatch, params){
      axios({
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${DailyAttendanceMiddleware.getToken()}`
          },
          url: url,
          responseType: 'json',
          params:params
        })
        .then((response) => {
          
          if (response && response.status === 200 && response.data) {
            dispatch(DailyAttendanceActions.list(response.data.result));
          }
        })
        .catch((error) => {
          DailyAttendanceMiddleware.alertHendler(dispatch,error)
        });
  }

  static showOne(dispatch, params){
    axios({
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${DailyAttendanceMiddleware.getToken()}`
        },
        url: url +'/'+params,
        responseType: 'json'
      })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(DailyAttendanceActions.view(response.data.result));
        }
      })
      .catch((error) => {
        DailyAttendanceMiddleware.alertHendler(dispatch,error)
      });
  }

  static delete(dispatch, params,id){
    axios({
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${DailyAttendanceMiddleware.getToken()}`
        },
        url: url +'/'+id,
        responseType: 'json'
      })
      .then((response) => {
       
        if (response && response.status === 200 && response.data) {
          MySwal.close()
          dispatch(DailyAttendanceActions.process(),DailyAttendanceMiddleware.showlist(dispatch, params));
          DailyAttendanceMiddleware.alertHendler(dispatch,response,true,'Delete Data Successfully','success')
        }
      })
      .catch((error) => {
        DailyAttendanceMiddleware.alertHendler(dispatch,error,true)
      });
  }

  static saveNew(dispatch, post,search){
    axios({
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${DailyAttendanceMiddleware.getToken()}`
        },
        url: url,
        data:post,
        responseType: 'json'
      })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(DailyAttendanceActions.process(),DailyAttendanceMiddleware.showlist(dispatch,search));
          dispatch(DailyAttendanceActions.success());
          DailyAttendanceMiddleware.alertHendler(dispatch,response,true,'Create Data Successfully','success')
        }
      })
      .catch((error) => {
        DailyAttendanceMiddleware.alertHendler(dispatch,error)
      });
  }

  static saveUpdate(dispatch, params, post){
    axios({
        method: 'PUT',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          Authorization: `Bearer ${DailyAttendanceMiddleware.getToken()}`
        },
        url: url+'/'+params,
        data:post,
        responseType: 'json'
      })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          // dispatch(DailyAttendanceActions.list(response.data.result));
          // dispatch(DailyAttendanceActions.showlist(dispatch,search));
          // dispatch(DailyAttendanceActions.success());
          // DailyAttendanceMiddleware.alertHendler(dispatch,response,true,'Update Data Successfully','success')
        }
      })
      .catch((error) => {
        DailyAttendanceMiddleware.alertHendler(dispatch,error)
      });
  }

  static alertHendler(dispatch,result,isSwal=false,extraMessage='',type='error'){
    if(type=='error'){
      if (result.response) {
        const status=result.response.status
        switch(status){
          
          case 500:
            if(isSwal){
              const data=result.response.data
              MySwal.hideLoading()
              MySwal.update({
                title:'Delete Error',
                html:data.error,
                icon:'error',
                showConfirmButton:true,
              })
            }else{
              const data=result.response.data
              dispatch(DailyAttendanceActions.error(data.error));
            }
          break;  
          case 403:
            console.log('Error 403');
          break;     
          case 404:
            console.log('Error 404');
          break;   
          case 401:
            const data=result.response.data
              MySwal.fire({
                title:'Login Invalid',
                html:data.error,
                icon:'error',
                showConfirmButton:true,
              }).then((result)=>{
                  if(result.isConfirmed){
                    <Navigate to="/login"></Navigate>
                  }
              })
          break;   
        }
      } else if (result.request) {
        MySwal.fire({
          title:'Internal Server Error',
          html:'Please info your Developer to fix this',
          icon:'error',
          showConfirmButton:true,
        })
        dispatch(DailyAttendanceActions.reset());
      } else {
        // Something happened in setting up the request that triggered an Error
        console.log('Error', result.message);
      }
    }else{
      MySwal.fire({
        title:'Success',
        html:extraMessage,
        icon:'success',
        showConfirmButton:true,
      })
    }
  }
}
